import Login from "views/Login.js";
import Tables from "views/Tables.js";
import RequestForm from "views/RequestForm.js";
import PatientForm from "views/PatientForm";
import NewDoctor from "views/NewDoctor";
import Completed from "views/Completed";
import CenterRequest from "views/CenterRequest";
import Expenses from "views/Expenses";
import PendingTable from "views/PendingTable";
// import Icons from "views/Icons";

var routes = [
  {
    path: "/tables",
    name: "Today Patients",
    icon: "ni ni-bullet-list-67 text-primary",
    component: Tables,
    layout: "/admin",
    show: true,
    type: "both",
  },
  // {
  //   path: "/index",
  //   name: "Dashboard",
  //   icon: "ni ni-tv-2 text-primary",
  //   component: Index,
  //   layout: "/admin",
  // },
  // {
  //   path: "/icons",
  //   name: "Icons",
  //   icon: "ni ni-planet text-primary",
  //   component: Icons,
  //   layout: "/admin",
  // },

  // {
  //   path: "/user-profile",
  //   name: "User Profile",
  //   icon: "ni ni-single-02 text-primary",
  //   component: Profile,
  //   layout: "/admin",
  // },
  {
    path: "/new-request",
    name: "New Request",
    icon: "ni ni-fat-add text-primary",
    component: RequestForm,
    layout: "/admin",
    show: true,
    type: "authenticated",
  },
  {
    path: "/completed",
    name: "Completed Patient",
    icon: "ni ni-bullet-list-67 text-primary",
    component: Completed,
    layout: "/admin",
    show: true,
    type: "center",
  },
  {
    path: "/completed",
    name: "Completed Patient",
    icon: "ni ni-bullet-list-67 text-primary",
    component: Completed,
    layout: "/admin",
    show: true,
    type: "admins",
  },
  {
    path: "/pending",
    name: "Pending Patient",
    icon: "ni ni-bullet-list-67 text-primary",
    component: PendingTable,
    layout: "/admin",
    show: true,
    type: "center",
  },
  {
    path: "/pending",
    name: "Pending Patient",
    icon: "ni ni-bullet-list-67 text-primary",
    component: PendingTable,
    layout: "/admin",
    show: true,
    type: "admins",
  },
  {
    path: "/new-doctor",
    name: "New Doctor",
    icon: "ni ni-fat-add text-primary",
    component: NewDoctor,
    layout: "/admin",
    show: true,
    type: "center",
  },
  {
    path: "/new-doctor",
    name: "New Doctor",
    icon: "ni ni-fat-add text-primary",
    component: NewDoctor,
    layout: "/admin",
    show: true,
    type: "admins",
  },
  {
    path: "/center-request",
    name: "New Request",
    icon: "ni ni-fat-add text-primary",
    component: CenterRequest,
    layout: "/admin",
    show: true,
    type: "center",
  },
  {
    path: "/center-request",
    name: "New Request",
    icon: "ni ni-fat-add text-primary",
    component: CenterRequest,
    layout: "/admin",
    show: true,
    type: "admins",
  },
  {
    path: "/expenses",
    name: "New Expenses",
    icon: "ni ni-fat-add text-primary",
    component: Expenses,
    layout: "/admin",
    show: true,
    type: "center",
  },
  {
    path: "/expenses",
    name: "New Expenses",
    icon: "ni ni-fat-add text-primary",
    component: Expenses,
    layout: "/admin",
    show: true,
    type: "admins",
  },
  {
    path: "/details/:userId",
    component: PatientForm,
    layout: "/admin",
    show: false,
    type: "both",
  },
  {
    path: "/login",
    name: "Login",
    icon: "ni ni-key-25 text-primary",
    component: Login,
    layout: "/auth",
    show: false,
    type: "both",
  },
];
export default routes;
